import React from 'react';
import styled from 'styled-components';
import { theme } from 'antd';

const { useToken } = theme;

interface GridBackgroundProps {
  isVisible: boolean;
  width?: string;
  height?: string;
}

const GridBackground: React.FC<GridBackgroundProps> = ({ isVisible, width, height }) => {
  const { token } = useToken();

  // Generate unique ID for the pattern to avoid conflicts
  const patternId = 'dotted-grid';

  if (!isVisible) return null;

  return (
    <GridContainer $width={width} $height={height}>
      <svg width={width ?? '100%'} height={height ?? '100%'}>
        <defs>
          <pattern id={patternId} width="25" height="25" patternUnits="userSpaceOnUse">
            <circle cx="12.5" cy="12.5" r="1.5" fill={token.colorBorder} opacity="0.4" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${patternId})`} />
      </svg>
    </GridContainer>
  );
};

const GridContainer = styled.div<{ $width?: string; $height?: string }>`
  position: absolute;
  background-color: ${({ theme: { token } }) => token.colorBgLayout};
  width: ${({ $width }) => $width ?? '100%'};
  height: ${({ $height }) => $height ?? '100%'};
  pointer-events: none;
  opacity: ${({ $width }) => ($width ? 0.4 : 1)};
`;

export default GridBackground;
